export const selectSelectedTicketIds = state => state.tickets.selected

export const selectSelectedPivotId = state => state.tickets.selectedPivotId

export const selectSelectedRangeEndId = state =>
  state.tickets.selectedRangeEndId

export const selectIsTicketSelectionMode = state =>
  !!state.tickets.isBulkSelectionMode
